import styled from 'styled-components';

export const SubscriptionListStyles = styled.div`
  width: 100%;
  margin: 20px 0 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
